import Header from './components/Header';
import Hero from './components/Hero';
import { SectionsGroup1 } from './components/SectionsGroup1';
import { SectionsGroup2 } from './components/SectionsGroup2';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-surface-950 text-white font-sans">
      <Header />
      <main>
        <Hero />
        <SectionsGroup1 />
        <SectionsGroup2 />
      </main>
      <Footer />
    </div>
  );
}